let ctx;
export const getCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (freq, start, dur, type = "sine", gain = 0.12) => {
  const c = getCtx();
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, c.currentTime + start);
  g.gain.setValueAtTime(0.0001, c.currentTime + start);
  g.gain.exponentialRampToValueAtTime(gain, c.currentTime + start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + start + dur);
  osc.connect(g).connect(c.destination);
  osc.start(c.currentTime + start);
  osc.stop(c.currentTime + start + dur + 0.05);
};

const safe = (fn) => () => {
  try { fn(); } catch (e) { /* audio unavailable */ }
};

export const sfx = {
  scan: safe(() => { tone(1320, 0, 0.08, "square", 0.05); tone(1760, 0.09, 0.1, "square", 0.05); }),
  reveal: safe(() => { [392, 523, 784].forEach((f, i) => tone(f, i * 0.09, 0.9, "triangle", 0.1)); }),
  known: safe(() => { tone(660, 0, 0.25, "sine", 0.08); tone(880, 0.12, 0.3, "sine", 0.06); }),
  error: safe(() => { tone(140, 0, 0.35, "sawtooth", 0.08); tone(110, 0.2, 0.4, "sawtooth", 0.08); }),
  unlock: safe(() => {
    [262, 330, 392, 523, 659, 784, 1047].forEach((f, i) => tone(f, i * 0.14, 1.2, "triangle", 0.09));
  }),
  step: (freq) => { try { tone(freq, 0, 0.45, "triangle", 0.1); tone(freq * 2, 0, 0.2, "sine", 0.03); } catch (e) { /* audio unavailable */ } },
  correct: safe(() => { tone(880, 0, 0.12, "sine", 0.08); tone(1320, 0.1, 0.3, "sine", 0.08); }),
  wrong: safe(() => { tone(220, 0, 0.18, "square", 0.05); tone(185, 0.16, 0.35, "square", 0.05); }),
  clarify: safe(() => { [523, 659, 784, 1047, 1319].forEach((f, i) => tone(f, i * 0.07, 1.4, "sine", 0.07)); }),
  tick: safe(() => { tone(1200, 0, 0.04, "square", 0.03); }),
};
